import React from "react"
import PropTypes from "prop-types"
import {
  SettingsCard,
  SettingsCardTitle,
  SettingsCardContent,
} from "@modules/site/settings"
import { SiteSettingsSection, SiteSettingsSectionLabel } from "../constants"
import IncrementalBuildsSettings from "./IncrementalBuildsSettings"
import { EnableBuilds } from "./EnableBuilds"
import EnableBuildChecks from "./EnableBuildChecks"
import { EnableAutomaticDeploys } from "./EnableAutomaticDeploys"
import { CdnVendor } from "@modules/graphql/types"
import { isProperlyConnected } from "@modules/site/cdnIntegrations"
import { useLocalSiteDetailsForBuilds } from "@modules/site/shared/hooks/useLocalSiteDetails"

const propTypes = {
  siteId: PropTypes.string.isRequired,
  organizationId: PropTypes.string.isRequired,
}

export default function BuildsSection({
  siteId,
  organizationId,
  buildsTier,
  hostingTier,
}) {
  const siteData = useLocalSiteDetailsForBuilds(siteId)
  const cdnIntegrations = siteData?.cdnIntegrations ?? []
  const activeIntegration = cdnIntegrations.find(isProperlyConnected)
  const gatsbyHostingOn = activeIntegration?.vendor === CdnVendor.CloudCdn

  if (!siteData) {
    return null
  }

  const buildsEnabled = siteData.buildsEnabled

  return (
    <SettingsCard>
      <SettingsCardTitle>
        {SiteSettingsSectionLabel[SiteSettingsSection.Builds]}
      </SettingsCardTitle>
      <SettingsCardContent
        css={theme => ({
          display: `grid`,
          gridGap: theme.space[7],
        })}
      >
        <EnableBuilds siteId={siteId} buildsEnabled={siteData.buildsEnabled} />
        {buildsEnabled && (
          <React.Fragment>
            <EnableBuildChecks
              siteId={siteId}
              buildChecksEnabled={siteData.buildChecksEnabled}
            />
            <IncrementalBuildsSettings
              siteId={siteId}
              organizationId={organizationId}
              incrementalBuildsEnabled={siteData.incrementalBuildsEnabled}
            />

            <EnableAutomaticDeploys
              siteId={siteId}
              organizationId={organizationId}
              manualHostingDeploysEnabled={siteData.manualHostingDeploysEnabled}
              gatsbyHostingOn={gatsbyHostingOn}
              buildsTier={buildsTier}
              hostingTier={hostingTier}
            />
          </React.Fragment>
        )}
      </SettingsCardContent>
    </SettingsCard>
  )
}

BuildsSection.propTypes = propTypes
